import { useEffect } from 'react';
import useBrand from '../branding/useBrand';

export default function useDocumentTitle(title) {
  const brand = useBrand();

  useEffect(() => {
    document.title = title ? `${title} | ${brand.titleBase}` : brand.titleBase;
  }, [brand.titleBase, title]);
}
